import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";
import type { TriggerButtonProps } from "@design-system/overlay/triggerButtonProps";

export interface LedgerBasisOption {
    value: string;
    label: string;
    disabled?: boolean;
    tooltip?: string;
}

interface Props {
    options: LedgerBasisOption[];
    value?: string;
    onChange: (value: string) => void;
    disabled?: boolean;
    className?: string;
    buttonSize?: TriggerButtonProps["size"];
    /** Render even when there is only one ledger to choose from. */
    shouldShowSingleOption?: boolean;
}

export const LedgerBasisSelect: React.FC<Props> = ({
    options,
    value,
    onChange,
    disabled,
    className,
    buttonSize = "md",
    shouldShowSingleOption = false,
}) => {
    if (
        options.length === 0 ||
        (options.length === 1 && !shouldShowSingleOption)
    ) {
        return null;
    }

    const currentValue =
        value ?? options.find((o) => !o.disabled)?.value ?? options[0]?.value;
    const items: Array<PickerItemData<string>> = options.map((option) => ({
        value: option.value,
        label: option.label,
        disabled: option.disabled,
        disabledReason: option.tooltip,
    }));

    return (
        <div className={className}>
            <Picker.Select
                items={items}
                value={currentValue}
                onValueChange={(v) => {
                    if (v) {
                        onChange(v);
                    }
                }}
                disabled={disabled}
                placeholder="Select basis"
                trigger={<Picker.Button variant="primary" size={buttonSize} />}
            />
        </div>
    );
};
